
<template>
    <div class="qi-cai-hzyc">
        <common></common>
    </div>
</template>

<script>

import common from './common.vue';

export default {
    components: {
        common
    },
    data () {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import '@css/var-hzyc.scss';

::v-deep .qi-cai {
    .qi-cont {
        .qi-cont-bot {
            .qi-list {
                .qi-item {
                    &:hover .qi-p p {
                        color: $primaryColor9 !important;
                    }
                }
            }
        }
    }
}
</style>
